import React from 'react';
import { cn } from '../../lib/cn';

export default function Skeleton({ className, ...rest }) {
  return (
    <div
      className={cn('bg-slate-200/70 rounded animate-pulse-soft', className)}
      {...rest}
    />
  );
}
